export enum InvestigationBatchStatus {
	Waiting = 1,
	Answered = 2,
	Expired = 3,
	Closed = 4,
	Request = 5,
}
